export const getRepoFullSlug = ({
  repositoryFullSlug: slug,
  repositoryOwner,
  repositorySlug,
}: Record<string, string | null | undefined>) =>
  slug || `${repositoryOwner}/${repositorySlug}`;
